<style scoped>
.ipt-sty {
  width: 70% !important;
}
.title-box {
  display: flex;
  align-items: center;
  padding-left: 50px;
}
.title-box-name{
  width: 126px;
  flex-shrink: 0;
  text-align: right;
}
.title-box-name span {
  color: red;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="search-area-div">功能名称：</div>
          <el-input size="mini" v-model="page.functionName" class="ipt-sty" placeholder="请输入功能名称" :clearable="true"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">功能编码：</div>
          <el-input size="mini" v-model="page.functionCode" class="ipt-sty" placeholder="请输入功能编码" :clearable="true"></el-input>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="add(1, '')">新增功能路径</el-button>
        <el-button size="mini" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      </div>
        <el-table @selection-change="handleSelectionChange" :height="height" :data="tableData" stripe border  style="width: 100%">
          <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
          <el-table-column prop="functionName" show-overflow-tooltip width="130"  label="功能名称" header-align="center" align="left"> </el-table-column>
          <el-table-column prop="functionCode" show-overflow-tooltip width="86" label="功能编码" header-align="center" align="left"> </el-table-column>
          <el-table-column prop="menuUrl" show-overflow-tooltip label="H5列表路径" header-align="center" align="left"> 
              <template slot-scope="scope">{{ scope.row.menuUrl || '-' }}</template>
          </el-table-column>
          <el-table-column prop="formUrl" show-overflow-tooltip label="H5新增路径" header-align="center" align="left">
             <template slot-scope="scope">{{ scope.row.formUrl || '-' }}</template>
          </el-table-column>
          <el-table-column prop="detailUrl" show-overflow-tooltip label="H5详情路径" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.detailUrl || '-' }}</template>
          </el-table-column>
            <el-table-column prop="appletMenuUrl" show-overflow-tooltip label="小程序列表路径" header-align="center" align="left"> 
                <template slot-scope="scope">{{ scope.row.appletMenuUrl || '-' }}</template>
            </el-table-column>
          <el-table-column prop="appletFormUrl" show-overflow-tooltip label="小程序新增路径" header-align="center" align="left"> 
              <template slot-scope="scope">{{ scope.row.appletFormUrl || '-' }}</template>
          </el-table-column>
          <el-table-column prop="appletDetailUrl" show-overflow-tooltip label="小程序详情路径" header-align="center" align="left">
            <template slot-scope="scope">{{ scope.row.appletDetailUrl || '-' }}</template>
          </el-table-column>
          <el-table-column width="90" label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
              <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10,20,100,100,200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="700px" :close-on-click-modal="false">
      <div class="title-box">
        <div class="title-box-name"><span>*</span>功能名称：</div>
        <el-input class="ipt-sty" v-model="ruleForm.functionName" :maxlength="20" placeholder="请和功能配置里面的功能名称保持一致"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>功能编码：</div>
        <el-input class="ipt-sty" v-model="ruleForm.functionCode" :maxlength="20" placeholder="请和功能配置里面的功能编码保持一致"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>H5新增路径：</div>
        <el-input class="ipt-sty" v-model="ruleForm.formUrl" :maxlength="100" placeholder="填写移动端新增路径"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span>*</span>H5列表路径：</div>
        <el-input class="ipt-sty" v-model="ruleForm.menuUrl" :maxlength="100" placeholder="填写移动端列表路径"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span style="color:white;">*</span>H5详情路径：</div>
        <el-input class="ipt-sty" v-model="ruleForm.detailUrl" :maxlength="100" placeholder="填写移动端详情路径"></el-input>
      </div>
         <div class="title-box mt15">
        <div class="title-box-name"><span style="color:white;">*</span>小程序新增路径：</div>
        <el-input class="ipt-sty" v-model="ruleForm.appletFormUrl" :maxlength="100" placeholder="填写移动端新增路径"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span style="color:white;">*</span>小程序列表路径：</div>
        <el-input class="ipt-sty" v-model="ruleForm.appletMenuUrl" :maxlength="100" placeholder="填写移动端列表路径"></el-input>
      </div>
      <div class="title-box mt15">
        <div class="title-box-name"><span style="color:white;">*</span>小程序详情路径：</div>
        <el-input class="ipt-sty" v-model="ruleForm.appletDetailUrl" :maxlength="100" placeholder="填写移动端详情路径"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="mini" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="mini" type="info" @click="submitForm()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 270,
      contentMainHeight: window.innerHeight - 200,
      dialogVisible: false,
      dialogFormVisible: false,
      ruleForm: {
        guid: null,
        functionCode: '',
        functionName:'',
        menuUrl:'',
        formUrl:'',
        detailUrl:'',
        appletFormUrl:'',
        appletMenuUrl:'',
        appletDetailUrl:'',
      },
      textTitle: '',
      page: {
        pageIndex: 1,
        pageSize: 100,
        totalPage: 0,
        totalRows: 0,
        functionCode:'',
        functionName:''
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      valueList:[],
      codeOption:[],
      codeList:[]
    };
  },
  created() {
    // 列表
    this.getData(false);
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 100,
        totalPage: 0,
        totalRows: 0,
        functionCode:'',
        functionName:''
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.loading = true;
      self.tableData = [];
      self.api.postJson(`/${serverConfig.msConfigureService}/function-path/list`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '新增功能路径';
        self.ruleForm.guid = null;
        self.ruleForm.functionCode	 = '';
        self.ruleForm.functionName = '';
        self.ruleForm.menuUrl = '';
        self.ruleForm.formUrl = '';
        self.ruleForm.detailUrl = '';
        self.ruleForm.appletFormUrl = '';
        self.ruleForm.appletMenuUrl = '';
        self.ruleForm.appletDetailUrl = '';
      } else {
        self.textTitle = '编辑功能路径';
        self.ruleForm.guid = row.guid;
        self.ruleForm.functionCode = row.functionCode;
        self.ruleForm.functionName = row.functionName;
        self.ruleForm.menuUrl = row.menuUrl;
        self.ruleForm.formUrl = row.formUrl;
        self.ruleForm.detailUrl = row.detailUrl;
        self.ruleForm.appletFormUrl = row.appletFormUrl;
        self.ruleForm.appletMenuUrl = row.appletMenuUrl;
        self.ruleForm.appletDetailUrl = row.appletDetailUrl;
      }
      self.dialogFormVisible = true;
    },
    submitForm() {
      let self = this;
      if (!self.ruleForm.functionName) {
        self.$message.error('功能名称不能为空！');
        return
      }
      if (!self.ruleForm.functionCode) {
        self.$message.error('功能编码不能为空！');
        return
      }

      if (!self.ruleForm.formUrl) {
        self.$message.error('新增路径不能为空！');
        return
      }
      if (!self.ruleForm.menuUrl) {
        self.$message.error('列表路径不能为空！');
        return
      }
      if(!this.ruleForm.guid){
        self.api.postJson(`/${serverConfig.msConfigureService}/function-path/add`, this.ruleForm).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success('添加成功');
                self.getData(true);
            } else {
            self.$message.error(res.data.msg);
            }
        });
      }else{
        self.api.put(`/${serverConfig.msConfigureService}/function-path/update`, this.ruleForm).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success('修改成功');
                self.getData(true);
            } else {
            self.$message.error(res.data.msg);
            }
        });
      }
      
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach( (item)=> {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
        // self.valueList.push(item.paramValue)
      });
      console.log(self.valueList)
    },
    
    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('删除后不可恢复, 确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msConfigureService}/function-path/del`, self.multipleSelection)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
